// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfluencerIcon_InfluencerIcon__fEtoK {
  display: inline-block;
  background: var(--bgColor);
  text-align: center;
  padding: 5px;
  position: relative;
}
.InfluencerIcon_InfluencerIcon__fEtoK img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
}
.InfluencerIcon_InfluencerIcon__fEtoK::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -14px;
  border: 7px solid transparent;
  border-top: var(--bgColor);
}
.InfluencerIcon_InfluencerIcon__fEtoK::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -14px;
  border: 7px solid transparent;
  border-top-color: var(--bgColor);
}`, "",{"version":3,"sources":["webpack://./src/app/components/TextMap/InfluencerIcon.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AAAE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,6BAAA;EACA,0BAAA;AAEJ;AAAE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,6BAAA;EACA,gCAAA;AAEJ","sourcesContent":[".InfluencerIcon {\n  display: inline-block;\n  background: var(--bgColor);\n  text-align: center;\n  padding: 5px;\n  position: relative;\n  img {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: -14px;\n    border: 7px solid transparent;\n    border-top: var(--bgColor);\n  }\n  &::after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: -14px;\n    border: 7px solid transparent;\n    border-top-color: var(--bgColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"InfluencerIcon": `InfluencerIcon_InfluencerIcon__fEtoK`
};
export default ___CSS_LOADER_EXPORT___;
